<p-toast position="top-right"></p-toast>

<ng-container *ngIf="draft; else cargando">
	<!-- Lo que rige HOY: una sola caja de cuatro casillas, como la franja de Exigibilidad. Sirve a
	     todos los roles y evita repetir los mismos valores en una vista de solo lectura aparte. -->
	<div class="wr-strip">
		<div class="wr-tile">
			<div class="wr-lbl">Mora</div>
			<div class="wr-val" [ngClass]="settings.mora.enabled ? 'is-good' : 'is-warn'">{{ settings.mora.enabled ? 'Encendida' : 'Apagada' }}</div>
			<div class="wr-sub">al apagar: <b>{{ settings.mora.offBehavior === 'PAUSE' ? 'en pausa' : 'sigue cobrando' }}</b></div>
		</div>
		<div class="wr-tile">
			<div class="wr-lbl">Tasa mensual por defecto</div>
			<div class="wr-val">{{ settings.mora.defaultMonthlyRate | percent:'1.1-2' }}</div>
			<div class="wr-sub"><b>{{ settings.mora.graceDays }}</b> {{ settings.mora.graceDays === 1 ? 'día' : 'días' }} de gracia · solo sella arrendamientos nuevos</div>
		</div>
		<div class="wr-tile">
			<div class="wr-lbl">Ventana de duplicados</div>
			<div class="wr-val">{{ settings.duplicates.windowDays }} días</div>
			<div class="wr-sub">sobre la fecha en que pagó el cliente</div>
		</div>
		<div class="wr-tile">
			<div class="wr-lbl">Ventana de calificación</div>
			<div class="wr-val">{{ settings.paymentQuality.windowPeriods }} letras</div>
			<div class="wr-sub">las últimas cubiertas que se evalúan</div>
		</div>
	</div>

	<!-- Dos columnas que se apilan por su cuenta: como rejilla de dos filas, la tarjeta más alta de
	     cada fila obligaba a la otra a dejar un hueco debajo. Con `auto-fit`, si la columna de edición
	     no se pinta —quien no es Admin—, la de la derecha ocupa el ancho completo sin quedar coja. -->
	<div class="wr-layout">
		<!-- Edición: solo con ['wallet','settings'] (Admin, D15). Quien no lo tiene lee la franja de arriba. -->
		<div class="wr-col" *appIfHasPermission="['wallet','settings']">
		<section class="wr-card">
			<header class="wr-card-h">
				<i class="pi pi-clock is-amber"></i>
				<h3>Mora</h3>
				<p-tag *ngIf="sectionDirty('mora')" value="sin guardar" severity="warning" styleClass="wr-dirty"></p-tag>
			</header>
			<div class="wr-card-b">
				<!-- El interruptor es el control más consecuente de la página: caja propia, con su estado
				     dicho en palabras al lado. Antes era una etiqueta y un switch a 700 px de distancia. -->
				<!-- El `for` va SOLO en el texto y no envolviendo la caja: con el switch dentro de la
				     etiqueta, el clic sobre él se reenvía al input oculto y PrimeNG lo alterna dos veces. -->
				<div class="wr-switch" [class.is-on]="draft.mora.enabled">
					<label class="wr-switch-t" for="moraEnabled">
						<span class="wr-switch-k">{{ draft.mora.enabled ? 'La mora se devenga cada noche' : 'La mora no se está devengando' }}</span>
						<span class="wr-switch-s">El devengo nocturno recalcula desde cero: encenderlo no inventa mora vieja, la vuelve a calcular.</span>
					</label>
					<p-inputSwitch [(ngModel)]="draft.mora.enabled" inputId="moraEnabled"></p-inputSwitch>
				</div>

				<div class="wr-field">
					<label for="moraOff">Comportamiento al apagar</label>
					<p-dropdown inputId="moraOff" [options]="offBehaviors" optionLabel="label" optionValue="value" [(ngModel)]="draft.mora.offBehavior" appendTo="body" styleClass="w-full"></p-dropdown>
					<small>{{ offBehaviorHelp }} Nada se borra en ninguno de los dos (M6).</small>
				</div>

				<div class="wr-cols">
					<!-- Tasa en %, igual que Contrato (§6.12): el decimal se deriva en onRatePctChange() -->
					<div class="wr-field">
						<label for="moraRate">Tasa mensual por defecto</label>
						<p-inputNumber inputId="moraRate" [(ngModel)]="ratePct" (onInput)="onRatePctChange()" suffix=" %" [minFractionDigits]="1" [maxFractionDigits]="2" [min]="0" [max]="20" styleClass="w-full"></p-inputNumber>
						<small>Entre 0 y 20 %. Solo aplica a arrendamientos nuevos: los vigentes sellan la suya al crearse (F24).</small>
					</div>
					<div class="wr-field">
						<label for="moraGrace">Días de gracia</label>
						<p-inputNumber inputId="moraGrace" [(ngModel)]="draft.mora.graceDays" [min]="0" [max]="30" styleClass="w-full"></p-inputNumber>
						<small>Días tras el vencimiento antes de que empiece a correr el devengo.</small>
					</div>
				</div>
			</div>
		</section>

		<section class="wr-card">
			<header class="wr-card-h">
				<i class="pi pi-clone is-blue"></i>
				<h3>Duplicados y calificación</h3>
				<p-tag *ngIf="sectionDirty('windows')" value="sin guardar" severity="warning" styleClass="wr-dirty"></p-tag>
			</header>
			<div class="wr-card-b">
				<div class="wr-field">
					<label for="dupWindow">Ventana de duplicados</label>
					<p-inputNumber inputId="dupWindow" [(ngModel)]="draft.duplicates.windowDays" [min]="1" [max]="365" suffix=" días" styleClass="w-full"></p-inputNumber>
					<small>Días sobre la fecha de pago dentro de los que un pago igual del mismo cliente se avisa como posible duplicado. Es evidencia, no veredicto: nunca bloquea el registro.</small>
				</div>
				<div class="wr-field">
					<label for="pqWindow">Ventana de letras para la calificación</label>
					<p-inputNumber inputId="pqWindow" [(ngModel)]="draft.paymentQuality.windowPeriods" [min]="3" [max]="60" suffix=" letras" styleClass="w-full"></p-inputNumber>
					<small>Últimas letras cubiertas que se miran para calificar a un cliente. Alimenta la banda de comportamiento de Exigibilidad.</small>
				</div>
			</div>
		</section>
		</div>

		<div class="wr-col">
		<!-- Matriz A-D -->
		<section class="wr-card">
		<header class="wr-card-h">
			<i class="fa-solid fa-star is-green"></i>
			<h3>Matriz de calificación</h3>
			<p-tag *ngIf="sectionDirty('grades')" value="sin guardar" severity="warning" styleClass="wr-dirty"></p-tag>
		</header>
		<div class="wr-card-b">
			<p class="wr-card-note">Se evalúa de arriba abajo y gana la primera que cumple las tres condiciones.</p>
			<div class="wr-table-wrap">
				<table class="wr-table">
					<thead>
						<tr>
							<th class="wr-col-grade">Letra</th>
							<th>Puntualidad mínima</th>
							<th>Retraso máximo</th>
							<th>Vencidas abiertas máx.</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let g of draft.paymentQuality.grades; let i = index; let last = last" [class.is-fallback]="last">
							<td class="wr-col-grade"><span class="wr-grade" [ngClass]="gradeClass(g.grade)">{{ g.grade }}</span></td>
							<ng-container *ngIf="canEdit && !last; else lectura">
								<!-- La puntualidad se captura en %, igual que la tasa de arriba: el decimal se deriva -->
								<td><p-inputNumber [inputId]="'wr-rate-' + g.grade" [ariaLabel]="'Puntualidad mínima de ' + g.grade" [(ngModel)]="gradePct[i]" (onInput)="onGradePctChange(i)" suffix=" %" [minFractionDigits]="0" [maxFractionDigits]="2" [min]="0" [max]="100" styleClass="w-full"></p-inputNumber></td>
								<td><p-inputNumber [inputId]="'wr-delay-' + g.grade" [ariaLabel]="'Retraso máximo de ' + g.grade" [(ngModel)]="g.maxDelayDays" [min]="0" suffix=" d" styleClass="w-full"></p-inputNumber></td>
								<td><p-inputNumber [inputId]="'wr-open-' + g.grade" [ariaLabel]="'Vencidas abiertas máximas de ' + g.grade" [(ngModel)]="g.maxOpenOverdue" [min]="0" styleClass="w-full"></p-inputNumber></td>
							</ng-container>
							<ng-template #lectura>
								<td>{{ g.minOnTimeRate != null ? (g.minOnTimeRate | percent:'1.0-0') : 'el resto' }}</td>
								<td>{{ g.maxDelayDays != null ? g.maxDelayDays + ' d' : '—' }}</td>
								<td>{{ g.maxOpenOverdue ?? '—' }}</td>
							</ng-template>
						</tr>
					</tbody>
				</table>
			</div>
			<p class="wr-table-note">La última letra no lleva condiciones: es la que recibe quien no cumple ninguna otra.</p>
		</div>
		</section>

		<!-- Historial: qué cambió, de qué a qué y por qué (WalletSettings.history), lo más reciente arriba.
		     Es la tarjeta que crece hasta emparejar el alto de la columna de al lado y la que desborda
		     por dentro: es la única de la pantalla cuyo contenido no tiene tope. -->
		<section class="wr-card wr-card-grow">
		<header class="wr-card-h">
			<i class="fa-solid fa-clock-rotate-left is-purple"></i>
			<h3>Historial</h3>
			<span class="wr-card-count" *ngIf="history.length">{{ history.length }}</span>
		</header>
		<div class="wr-card-b">
			<div class="wr-events" *ngIf="history.length; else sinHistorial">
				<div class="wr-ev" *ngFor="let h of history">
					<span class="wr-ev-dt">{{ h.date | date:'dd/MM/yyyy HH:mm' }}</span>
					<span class="wr-ev-dot" [ngClass]="'is-' + h.tone" aria-hidden="true"></span>
					<span class="wr-ev-body">
						<b>{{ h.label }}</b><span class="wr-ev-who" *ngIf="h.user"> · {{ h.user }}</span>
						<span class="wr-ev-change" [class.is-stacked]="h.stacked">
							<span class="wr-ev-before">{{ h.before }}</span>
							<i class="pi pi-arrow-right" aria-hidden="true"></i>
							<span class="wr-ev-after">{{ h.after }}</span>
						</span>
						<span class="wr-ev-reason" *ngIf="h.reason">{{ h.reason }}</span>
					</span>
				</div>
			</div>
			<ng-template #sinHistorial><p class="wr-empty">Sin cambios registrados.</p></ng-template>
		</div>
		</section>
		</div>
	</div>

	<!-- Guardar: solo Admin. Va a lo ancho y al final porque confirma TODO lo editable de la pantalla
	     —mora, ventanas y matriz viajan en el mismo PUT—, no lo de una columna. -->
	<div class="wr-save" [class.is-dirty]="isDirty" *appIfHasPermission="['wallet','settings']">
		<p class="wr-save-pending" *ngIf="pendingChanges.length">
			<i class="pi pi-pencil"></i>
			<span><b>{{ pendingChanges.length }} {{ pendingChanges.length === 1 ? 'cambio' : 'cambios' }} sin guardar</b> · {{ pendingChanges.join(' · ') }}</span>
		</p>
		<div class="wr-field wr-save-field">
			<label for="wrReason">Motivo del cambio</label>
			<textarea id="wrReason" pInputTextarea [(ngModel)]="reason" rows="2" [maxlength]="500" placeholder="Por qué se cambia y quién lo pidió"></textarea>
		</div>
		<!-- La ayuda va ANTES del botón en el orden del documento: colocada después, la rejilla ya no
		     puede retroceder a la primera columna de esa fila y los dos quedaban en renglones distintos. -->
		<p class="wr-save-hint" [class.is-error]="lastGradeHasConditions">
			<i class="pi" [ngClass]="lastGradeHasConditions ? 'pi-exclamation-triangle' : 'pi-info-circle'"></i>
			<span>{{ saveHint }}</span>
		</p>
		<button pButton type="button" label="Guardar reglas" icon="pi pi-check" class="p-button-success wr-save-btn" (click)="save()" [disabled]="!canSave" [loading]="saving"></button>
	</div>
</ng-container>

<ng-template #cargando>
	<!-- Carga: la misma pantalla que viene, en gris. Lleva las clases reales —`wr-strip`, `wr-layout`,
	     `wr-card`—, así que la geometría sale de ahí y al llegar las reglas nada salta de sitio.
	     Respeta el permiso: quien no edita tampoco ve el esqueleto de la columna de edición. -->
	<ng-container *ngIf="loading" aria-busy="true">
		<div class="wr-strip" aria-label="Cargando las reglas vigentes">
			<div class="wr-tile" *ngFor="let t of [1, 2, 3, 4]">
				<p-skeleton height="0.72rem" width="8rem"></p-skeleton>
				<p-skeleton height="1.375rem" width="6rem"></p-skeleton>
				<p-skeleton height="0.75rem" width="100%"></p-skeleton>
			</div>
		</div>

		<div class="wr-layout">
			<div class="wr-col" *appIfHasPermission="['wallet','settings']">
				<section class="wr-card">
					<header class="wr-card-h"><p-skeleton shape="circle" size="1.05rem"></p-skeleton><p-skeleton height="1rem" width="5rem"></p-skeleton></header>
					<div class="wr-card-b">
						<p-skeleton height="4.6rem" borderRadius="10px"></p-skeleton>
						<div class="wr-field">
							<p-skeleton height="0.75rem" width="11rem"></p-skeleton>
							<p-skeleton height="2.6rem" borderRadius="6px"></p-skeleton>
							<p-skeleton height="0.72rem" width="90%"></p-skeleton>
						</div>
						<div class="wr-cols">
							<div class="wr-field" *ngFor="let f of [1, 2]">
								<p-skeleton height="0.75rem" width="9rem"></p-skeleton>
								<p-skeleton height="2.6rem" borderRadius="6px"></p-skeleton>
								<p-skeleton height="0.72rem" width="85%"></p-skeleton>
							</div>
						</div>
					</div>
				</section>

				<section class="wr-card">
					<header class="wr-card-h"><p-skeleton shape="circle" size="1.05rem"></p-skeleton><p-skeleton height="1rem" width="12rem"></p-skeleton></header>
					<div class="wr-card-b">
						<div class="wr-field" *ngFor="let f of [1, 2]">
							<p-skeleton height="0.75rem" width="13rem"></p-skeleton>
							<p-skeleton height="2.6rem" borderRadius="6px"></p-skeleton>
							<p-skeleton height="0.72rem" width="95%"></p-skeleton>
						</div>
					</div>
				</section>
			</div>

			<div class="wr-col">
				<section class="wr-card">
					<header class="wr-card-h"><p-skeleton shape="circle" size="1.05rem"></p-skeleton><p-skeleton height="1rem" width="10rem"></p-skeleton></header>
					<div class="wr-card-b">
						<p-skeleton height="0.75rem" width="90%"></p-skeleton>
						<div class="wr-table-wrap">
							<div class="wr-sk-row is-head"><p-skeleton height="0.72rem" width="3rem"></p-skeleton><p-skeleton height="0.72rem" width="8rem"></p-skeleton><p-skeleton height="0.72rem" width="7rem"></p-skeleton><p-skeleton height="0.72rem" width="9rem"></p-skeleton></div>
							<div class="wr-sk-row" *ngFor="let g of [1, 2, 3, 4]" [ngClass]="'sk-fade-' + g">
								<p-skeleton width="1.75rem" height="1.75rem" borderRadius="8px"></p-skeleton>
								<p-skeleton height="2.2rem" borderRadius="6px"></p-skeleton>
								<p-skeleton height="2.2rem" borderRadius="6px"></p-skeleton>
								<p-skeleton height="2.2rem" borderRadius="6px"></p-skeleton>
							</div>
						</div>
						<p-skeleton height="0.72rem" width="70%"></p-skeleton>
					</div>
				</section>

				<section class="wr-card wr-card-grow">
					<header class="wr-card-h"><p-skeleton shape="circle" size="1.05rem"></p-skeleton><p-skeleton height="1rem" width="6rem"></p-skeleton></header>
					<div class="wr-card-b">
						<div class="wr-events">
							<!-- La opacidad decrece hacia abajo: sugiere que el historial sigue sin fingir cuántas entradas trae. -->
							<div class="wr-ev" *ngFor="let e of [1, 2, 3, 4]" [ngClass]="'sk-fade-' + e">
								<p-skeleton height="0.74rem" width="7rem"></p-skeleton>
								<p-skeleton shape="circle" size="0.5rem" styleClass="wr-sk-dot"></p-skeleton>
								<div class="wr-ev-body">
									<p-skeleton height="0.78rem" width="11rem"></p-skeleton>
									<p-skeleton height="0.74rem" width="14rem"></p-skeleton>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>

		<div class="wr-save" *appIfHasPermission="['wallet','settings']">
			<div class="wr-field wr-save-field">
				<p-skeleton height="0.75rem" width="9rem"></p-skeleton>
				<p-skeleton height="4rem" borderRadius="6px"></p-skeleton>
			</div>
			<p-skeleton height="0.75rem" width="14rem" class="wr-sk-hint"></p-skeleton>
			<p-skeleton height="2.6rem" width="10rem" borderRadius="6px" class="wr-save-btn"></p-skeleton>
		</div>
	</ng-container>

	<div class="wr-state" *ngIf="error">
		<i class="pi pi-exclamation-triangle"></i>
		<h3>No se pudieron leer las reglas</h3>
		<p>{{ error }}</p>
		<button pButton type="button" label="Reintentar" icon="pi pi-refresh" class="p-button-outlined p-button-sm" (click)="load()"></button>
	</div>
</ng-template>
